
import React, { useState } from 'react';
import Button from 'components/form/Button';
import Label from 'components/form/Label';
import UploadInput from 'components/form/UploadInput';
import Card from 'components/Layout/Card';
import { generatePreSignedUrl, objectToFormData } from 'utils/helpers';
import { eventAbstarctPath, icons } from 'utils/constants';
import Loader from 'components/Layout/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { removeAiSubmitAbstract, storeAiAbstractData } from 'store/slices';

const UploadAbstract = ({
  values,
  setFieldValue,
  handleChange,
  errors,
  touched,
  onNext,

  btnLoading
}) => {
  const navigate = useNavigate()
  const params = useParams();
  const dispatch = useDispatch()
  const reduxData = useSelector((state) => state.aiAbstractSubmission);
  const { aiAbstractData } = reduxData || {};

  const [loading, setLoading] = useState(false)
  const handleFileChange = (e) => {
    const { id, value, files } = e.target;
    setFieldValue('abstractPathFileName', files?.[0]?.name || '');
    setFieldValue(id, value);
    handleChange(e);
  };

  const handleViewPreview = async (previewFile) => {
    if (previewFile) {
      const res = await generatePreSignedUrl(previewFile, eventAbstarctPath);
      const fileEx = previewFile?.split('.')?.pop();

      if (fileEx !== 'pdf') {
        const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(res)}&embedded=true`;
        window.open(googleDocsUrl, '_blank');
      } else {
        window.open(res, '_blank');
      }
    }
  };

  const handleRemoveFile = async () => {
    setLoading(true);
    const response = await dispatch(
      removeAiSubmitAbstract(
        objectToFormData({
          id: aiAbstractData?.ai_abstract_id,
        })
      )
    );
    if (response?.status === 200) {
      dispatch(storeAiAbstractData())
      window.location.reload();
    }
    setLoading(false);
  }


  return (
    <Card className="cp-20">
      <div className="text-16-500 color-1717 cmb-20">Paper Details</div>
      <div className="border-bottom cmb-20 color-d1d1"></div>

      <Label label="Choose Your Submission Type *" className="text-14-400-18" />

      <div className="row cmt-12">
        {(!aiAbstractData?.abstract_file) ?
          <>
            <div className="col-md-6 col-12">
              <Label label="Upload Abstract" className="text-14-400-18 color-6866" />
              <UploadInput
                multiple={false}
                id="abstract_path"
                value={values?.abstract_path}
                supportedFormats={['PDF', 'DOCX']}
                handleChange={handleFileChange}
                disabled={values?.full_paper_path}
                isAiAbstract
              />
              {errors.abstract_path && touched.abstract_path && (
                <div className="text-danger">{errors.abstract_path}</div>
              )}
            </div>

            <div className="col-md-6 col-12">
              <Label label="Full Paper Submission" className="text-14-400-18 color-6866" />
              <UploadInput
                multiple={false}
                id="full_paper_path"
                value={values?.full_paper_path || ''}
                supportedFormats={['PDF', 'DOCX']}
                handleChange={handleFileChange}
                disabled={values?.abstract_path}
                isAiAbstract
              />
              {errors.full_paper_path && touched.full_paper_path && (
                <div className="text-danger">{errors.full_paper_path}</div>
              )}
            </div>
          </>
          : (
            <div className="cmb-16">
              <div className="file-uploaded-box d-flex align-items-center justify-content-between w-100 bg-f6ff">
                <div className="d-flex flex-column justify-content-center  w-100">
                  <span className="file-name text-14-500 color-6866 text-center" >
                    {aiAbstractData?.abstract_file}
                  </span>
                  <span className="text-12-500 color-6866 text-center">
                    Submission Type: {aiAbstractData?.submission_type || ''}
                  </span>
                </div>


                <div className="d-flex align-items-center gap-2">
                  <i
                    style={{ fontSize: "20px", fontWeight: 500 }}
                    className="bi bi-eye text-primary pointer"
                    title="Preview"
                    onClick={() => handleViewPreview(aiAbstractData?.abstract_file)}
                  />

                  {loading ? <Loader size="sm" /> :
                    <i
                      style={{ fontSize: "24px", fontWeight: 500 }}
                      className="bi bi-trash delete-icon color-danger pointer"
                      title="Delete"
                      onClick={() => handleRemoveFile()}
                    />}
                </div>
              </div>


            </div>
          )}
      </div>

      {aiAbstractData?.word_count &&
        <div className="text-14-400-18 cmt-12 color-black-olive d-flex align-items-center">
          <img
            src={icons.abstractDone}
            height={16}
            width={16}
            className="me-1"
            alt=""
            loading='lazy'
          />
          {`Our AI has successfully parsed your abstract and extracted the following information, Total ${aiAbstractData?.word_count} word counts found !!`}
        </div>}


      <div className="d-flex gap-3 cmt-20">
        <Button
          id="btn_cancel"
          text="Cancel"
          btnStyle="light-outline"
          className="cps-40 cpe-40 h-38"
          onClick={() => {
            navigate(`/${params?.memberType}/conferences-and-events/iferp-events/event-list/conference`);
          }}
          disabled={btnLoading}
        />
        <Button
          id="btn_submission_upload"
          text="Proceed Next"
          btnStyle="primary-dark"
          className="cps-40 cpe-40 h-38"
          onClick={onNext}
          btnLoading={btnLoading}
          disabled={(!values?.abstract_path && !values?.full_paper_path) || btnLoading}
        />
      </div>
    </Card>
  );
};

export default UploadAbstract;

